import React, { useState } from 'react';

// SVG design previews — abstract Gen Z aesthetic rendered inline
const designs = [
  {
    id: 'flame-type',
    name: 'FLAME TYPE',
    desc: 'Distorted serif letterforms, heat-warped. Oversized back graphic.',
    colorway: 'Washed Black',
    hex: '#1a1a1a',
    textHex: '#C8440A',
    svg: (
      <svg viewBox="0 0 300 380" style={{ width: '100%', height: '100%' }}>
        <rect width="300" height="380" fill="#1a1a1a" />
        {/* Distorted REVIVE text */}
        <text x="150" y="160" textAnchor="middle" fontFamily="serif" fontSize="72" fontWeight="900"
          fill="none" stroke="#C8440A" strokeWidth="1.5"
          style={{ letterSpacing: '-4px' }}>REVIVE</text>
        <text x="152" y="162" textAnchor="middle" fontFamily="serif" fontSize="72" fontWeight="900"
          fill="#C8440A" opacity="0.15"
          style={{ letterSpacing: '-4px' }}>REVIVE</text>
        {/* Flame wisps */}
        <path d="M80 280 Q90 240 100 220 Q110 240 105 270 Q115 230 125 200 Q135 230 130 260 Q145 210 155 180 Q165 215 158 250 Q170 205 180 175 Q190 210 183 245 Q195 220 205 195 Q215 225 208 260 Q218 235 225 210 Q230 240 220 280 Z" 
          fill="#C8440A" opacity="0.7" />
        <path d="M100 280 Q110 255 115 235 Q122 255 118 272 Q128 245 135 220 Q143 248 138 268 Q150 235 158 210 Q166 238 160 262 Z"
          fill="#D4A843" opacity="0.5" />
        {/* Year tag */}
        <text x="150" y="340" textAnchor="middle" fontFamily="monospace" fontSize="11" fill="#F5F0E8" opacity="0.3" letterSpacing="6">2026</text>
        {/* Abstract line */}
        <line x1="60" y1="200" x2="240" y2="200" stroke="#C8440A" strokeWidth="0.5" opacity="0.3" />
      </svg>
    ),
  },
  {
    id: 'city-grid',
    name: 'CITY GRID',
    desc: 'Urban data map of all 8 cities. Coordinates printed in micro-type.',
    colorway: 'Vintage White',
    hex: '#F0EBE0',
    textHex: '#080808',
    svg: (
      <svg viewBox="0 0 300 380" style={{ width: '100%', height: '100%' }}>
        <rect width="300" height="380" fill="#F0EBE0" />
        {/* Grid lines */}
        {[0,1,2,3,4,5].map(i => (
          <line key={`h${i}`} x1="30" y1={80 + i * 45} x2="270" y2={80 + i * 45} stroke="#080808" strokeWidth="0.3" opacity="0.2" />
        ))}
        {[0,1,2,3,4,5,6].map(i => (
          <line key={`v${i}`} x1={30 + i * 40} y1="60" x2={30 + i * 40} y2="305" stroke="#080808" strokeWidth="0.3" opacity="0.2" />
        ))}
        {/* City dots */}
        {[
          [110, 185, 'LA'], [190, 130, 'DAL'], [100, 175, 'SF'],
          [75, 230, 'HI'], [210, 175, 'LA'], [155, 125, 'CO'], [220, 185, 'ATL']
        ].map(([x, y, label], i) => (
          <g key={i}>
            <circle cx={x} cy={y} r="4" fill="#C8440A" />
            <circle cx={x} cy={y} r="8" fill="none" stroke="#C8440A" strokeWidth="0.8" opacity="0.4" />
            <text x={x + 10} y={y + 4} fontFamily="monospace" fontSize="7" fill="#080808" opacity="0.5">{label}</text>
          </g>
        ))}
        {/* REVIVE large */}
        <text x="150" y="50" textAnchor="middle" fontFamily="serif" fontSize="28" fontWeight="900" fill="#080808" letterSpacing="6">REVIVE</text>
        {/* Coordinate micro text */}
        <text x="150" y="330" textAnchor="middle" fontFamily="monospace" fontSize="7" fill="#080808" opacity="0.4" letterSpacing="2">34.0522°N 118.2437°W · 32.7767°N 97.7970°W</text>
        <text x="150" y="342" textAnchor="middle" fontFamily="monospace" fontSize="7" fill="#080808" opacity="0.4" letterSpacing="2">21.3069°N 157.8583°W · 29.9511°N 90.0715°W</text>
        <text x="150" y="354" textAnchor="middle" fontFamily="monospace" fontSize="7" fill="#C8440A" opacity="0.6" letterSpacing="3">ALL CITIES · 2026</text>
      </svg>
    ),
  },
  {
    id: 'wake',
    name: 'WAKE',
    desc: 'Minimal. One word. Cracked earth texture. Front chest print.',
    colorway: 'Stone Grey',
    hex: '#2C2C2C',
    textHex: '#F5F0E8',
    svg: (
      <svg viewBox="0 0 300 380" style={{ width: '100%', height: '100%' }}>
        <rect width="300" height="380" fill="#2C2C2C" />
        {/* Cracked texture lines */}
        {[
          'M150 100 Q160 130 155 160 Q148 185 152 210',
          'M152 210 Q158 230 145 255 Q135 270 140 290',
          'M150 100 Q135 125 138 150 Q142 170 135 195',
          'M135 195 Q128 215 132 240 Q138 260 130 285',
          'M152 210 Q165 220 180 215 Q200 210 215 225',
          'M150 100 Q168 110 178 135 Q185 155 195 165',
        ].map((d, i) => (
          <path key={i} d={d} stroke="#F5F0E8" strokeWidth={i < 2 ? 1.5 : 0.8} fill="none" opacity={i < 2 ? 0.6 : 0.2} />
        ))}
        {/* WAKE text */}
        <text x="150" y="200" textAnchor="middle" fontFamily="serif" fontSize="88" fontWeight="900"
          fill="none" stroke="#F5F0E8" strokeWidth="1" opacity="0.9"
          style={{ letterSpacing: '-2px' }}>WAKE</text>
        <text x="150" y="200" textAnchor="middle" fontFamily="serif" fontSize="88" fontWeight="900"
          fill="#F5F0E8" opacity="0.08"
          style={{ letterSpacing: '-2px' }}>WAKE</text>
        {/* Sub */}
        <text x="150" y="225" textAnchor="middle" fontFamily="monospace" fontSize="9" fill="#C8440A" opacity="0.8" letterSpacing="5">REVIVE 2026</text>
        {/* Ember glow */}
        <ellipse cx="150" cy="210" rx="90" ry="40" fill="#C8440A" opacity="0.04" />
      </svg>
    ),
  },
  {
    id: 'signal',
    name: 'SIGNAL',
    desc: 'Broadcast wave graphic. The message is going out. Full back print.',
    colorway: 'Bone',
    hex: '#E8E0D0',
    textHex: '#080808',
    svg: (
      <svg viewBox="0 0 300 380" style={{ width: '100%', height: '100%' }}>
        <rect width="300" height="380" fill="#E8E0D0" />
        {/* Broadcast arcs */}
        {[30, 55, 80, 105, 130].map((r, i) => (
          <path key={i} d={`M${150 - r * 0.7} ${220 + r * 0.3} A${r} ${r} 0 0 1 ${150 + r * 0.7} ${220 + r * 0.3}`}
            fill="none" stroke="#080808" strokeWidth={i === 0 ? 2 : 1}
            opacity={0.6 - i * 0.1} />
        ))}
        {/* Center dot */}
        <circle cx="150" cy="220" r="5" fill="#C8440A" />
        <circle cx="150" cy="220" r="10" fill="none" stroke="#C8440A" strokeWidth="1" opacity="0.4" />
        {/* SIGNAL text */}
        <text x="150" y="130" textAnchor="middle" fontFamily="serif" fontSize="54" fontWeight="900"
          fill="#080808" letterSpacing="4">SIGNAL</text>
        <text x="150" y="155" textAnchor="middle" fontFamily="monospace" fontSize="9"
          fill="#C8440A" letterSpacing="5" opacity="0.8">REVIVE · 2026</text>
        {/* Static noise dots */}
        {Array.from({ length: 60 }, (_, i) => (
          <circle key={i} cx={50 + Math.sin(i * 2.5) * 100 + (i % 7) * 30} cy={260 + (i % 5) * 15}
            r="1" fill="#080808" opacity={0.05 + (i % 3) * 0.05} />
        ))}
        <text x="150" y="355" textAnchor="middle" fontFamily="monospace" fontSize="8"
          fill="#080808" opacity="0.3" letterSpacing="3">THE MESSAGE IS GOING OUT</text>
      </svg>
    ),
  },
];

const products = [
  { type: 'Oversized Tee', sizes: ['S','M','L','XL','XXL'], price: '$35' },
  { type: 'Oversized Hoodie', sizes: ['S','M','L','XL','XXL'], price: '$65' },
];

const inputStyle = { width: '100%', background: 'rgba(8,8,8,0.5)', border: '1px solid rgba(245,240,232,0.12)', color: 'var(--white)', padding: '12px 14px', fontFamily: 'var(--font-body)', fontSize: 13, outline: 'none', transition: 'border-color 0.3s', marginBottom: 10 };
const labelStyle = { display: 'block', fontSize: 9, letterSpacing: '0.25em', textTransform: 'uppercase', color: 'rgba(245,240,232,0.4)', marginBottom: 6 };

function PreorderForm({ design, onClose }) {
  const [form, setForm] = useState({ name: '', email: '', productType: '', size: '', quantity: '1', 'bot-field': '' });
  const [submitted, setSubmitted] = useState(false);
  const set = k => e => setForm({ ...form, [k]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const body = new URLSearchParams({ 'form-name': 'merch-preorder', design: design.name, ...form });
    await fetch('/', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body.toString() });
    setSubmitted(true);
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(8,8,8,0.92)', zIndex: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ background: 'var(--ash)', border: '1px solid rgba(200,68,10,0.2)', padding: 48, maxWidth: 520, width: '100%', position: 'relative', maxHeight: '90vh', overflowY: 'auto' }}>
        <button onClick={onClose} style={{ position: 'absolute', top: 20, right: 24, background: 'none', border: 'none', color: 'rgba(245,240,232,0.4)', fontSize: 22, lineHeight: 1 }}>✕</button>

        {!submitted ? (
          <>
            <p style={{ fontSize: 9, letterSpacing: '0.3em', textTransform: 'uppercase', color: 'var(--ember)', marginBottom: 8 }}>Pre-Order</p>
            <h3 style={{ fontFamily: 'var(--font-display)', fontSize: 36, color: 'var(--white)', marginBottom: 4 }}>{design.name}</h3>
            <p style={{ fontSize: 13, color: 'rgba(245,240,232,0.4)', fontFamily: 'var(--font-serif)', fontStyle: 'italic', marginBottom: 28 }}>{design.desc}</p>

            <form onSubmit={handleSubmit} name="merch-preorder" data-netlify="true" netlify-honeypot="bot-field">
              <input type="hidden" name="form-name" value="merch-preorder" />
              <input type="hidden" name="design" value={design.name} />
              <input type="hidden" name="bot-field" value={form['bot-field']} />

              <label style={labelStyle}>Full Name</label>
              <input required value={form.name} onChange={set('name')} placeholder="Your name" style={inputStyle} />

              <label style={labelStyle}>Email</label>
              <input required type="email" value={form.email} onChange={set('email')} placeholder="your@email.com" style={inputStyle} />

              <label style={labelStyle}>Product</label>
              <select required value={form.productType} onChange={set('productType')}
                style={{ ...inputStyle, appearance: 'none', background: 'rgba(8,8,8,0.8)', color: form.productType ? 'var(--white)' : 'rgba(245,240,232,0.35)' }}>
                <option value="" disabled>Select product</option>
                {products.map(p => <option key={p.type}>{p.type} — {p.price}</option>)}
              </select>

              <label style={labelStyle}>Size</label>
              <select required value={form.size} onChange={set('size')}
                style={{ ...inputStyle, appearance: 'none', background: 'rgba(8,8,8,0.8)', color: form.size ? 'var(--white)' : 'rgba(245,240,232,0.35)' }}>
                <option value="" disabled>Select size</option>
                {['XS','S','M','L','XL','XXL'].map(s => <option key={s}>{s}</option>)}
              </select>

              <label style={labelStyle}>Quantity</label>
              <select value={form.quantity} onChange={set('quantity')}
                style={{ ...inputStyle, appearance: 'none', background: 'rgba(8,8,8,0.8)', color: 'var(--white)' }}>
                {['1','2','3','4','5'].map(n => <option key={n}>{n}</option>)}
              </select>

              <div style={{ padding: '14px 16px', background: 'rgba(212,168,67,0.06)', border: '1px solid rgba(212,168,67,0.15)', marginBottom: 16, fontSize: 12, color: 'rgba(245,240,232,0.5)', lineHeight: 1.6 }}>
                <strong style={{ color: 'var(--gold)' }}>Pre-order note:</strong> Items ship 2–3 weeks after your city's REVIVE event. Payment collected at fulfilment. You'll receive a confirmation email shortly.
              </div>

              <button type="submit" style={{ width: '100%', background: 'var(--ember)', color: 'var(--white)', border: 'none', padding: '16px', fontFamily: 'var(--font-body)', fontSize: 12, fontWeight: 500, letterSpacing: '0.2em', textTransform: 'uppercase' }}
                onMouseEnter={e => e.target.style.background = 'var(--ember-light)'}
                onMouseLeave={e => e.target.style.background = 'var(--ember)'}>
                Reserve My Piece
              </button>
            </form>
          </>
        ) : (
          <div style={{ textAlign: 'center', padding: '24px 0' }}>
            <div style={{ fontFamily: 'var(--font-display)', fontSize: 48, color: 'var(--ember)', marginBottom: 12 }}>RESERVED.</div>
            <p style={{ fontFamily: 'var(--font-serif)', fontStyle: 'italic', fontSize: 18, color: 'rgba(245,240,232,0.55)', marginBottom: 8 }}>
              Your <strong style={{ color: 'var(--white)' }}>{design.name}</strong> pre-order is locked in.
            </p>
            <p style={{ fontSize: 12, color: 'rgba(245,240,232,0.3)' }}>Check your email for confirmation.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default function Merch() {
  const [selectedDesign, setSelectedDesign] = useState(null);
  const [hovered, setHovered] = useState(null);
  const [activeDesign, setActiveDesign] = useState(0);

  return (
    <>
      {selectedDesign && <PreorderForm design={selectedDesign} onClose={() => setSelectedDesign(null)} />}

      <section id="merch" style={{ padding: '120px 64px', background: 'var(--black)', position: 'relative', overflow: 'hidden' }}>
        {/* hidden netlify form for detection */}
        <form name="merch-preorder" data-netlify="true" netlify-honeypot="bot-field" hidden>
          <input type="text" name="name" />
          <input type="email" name="email" />
          <input type="text" name="productType" />
          <input type="text" name="size" />
          <input type="text" name="quantity" />
          <input type="text" name="design" />
        </form>

        <style>{`
          @media(max-width:900px){ #merch{padding:80px 24px!important;} .merch-grid{grid-template-columns:repeat(2,1fr)!important;} .merch-hero{grid-template-columns:1fr!important;} }
          @media(max-width:480px){ .merch-grid{grid-template-columns:1fr!important;} }
          .merch-card { transition: border-color 0.3s, transform 0.3s; }
          .merch-card:hover { border-color: rgba(200,68,10,0.5) !important; transform: translateY(-4px); }
        `}</style>

        {/* Ghost text bg */}
        <div style={{ position: 'absolute', fontFamily: 'var(--font-display)', fontSize: 'clamp(120px,20vw,240px)', color: 'rgba(200,68,10,0.025)', right: -20, top: '10%', letterSpacing: '0.05em', pointerEvents: 'none', whiteSpace: 'nowrap' }}>MERCH</div>

        <p className="reveal" style={{ fontSize: 10, letterSpacing: '0.35em', textTransform: 'uppercase', color: 'var(--ember)', marginBottom: 20 }}>Official Collection</p>
        <h2 className="reveal" style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(48px,6vw,80px)', lineHeight: 0.95, color: 'var(--white)', marginBottom: 20 }}>
          WEAR THE<br />MOVEMENT
        </h2>
        <div className="reveal" style={{ width: 48, height: 3, background: 'linear-gradient(90deg,var(--ember),var(--gold))', margin: '0 0 24px' }} />
        <p className="reveal" style={{ fontFamily: 'var(--font-serif)', fontStyle: 'italic', fontSize: 18, color: 'rgba(245,240,232,0.5)', maxWidth: 520, marginBottom: 64 }}>
          Limited pre-order. Abstract designs for a generation that refuses to be silent. Oversized fits. Ships after your city's REVIVE event.
        </p>

        {/* Featured design preview */}
        <div className="merch-hero reveal" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 64, alignItems: 'center', marginBottom: 80 }}>
          <div style={{ position: 'relative' }}>
            {/* Mock shirt shape */}
            <div style={{ background: designs[activeDesign].hex, aspectRatio: '3/4', position: 'relative', overflow: 'hidden', border: `1px solid rgba(245,240,232,0.06)` }}>
              <div style={{ position: 'absolute', inset: '8% 12%' }}>
                {designs[activeDesign].svg}
              </div>
              {/* Shirt collar hint */}
              <div style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', width: '30%', height: '8%', background: designs[activeDesign].hex, borderRadius: '0 0 50% 50%', border: `1px solid rgba(245,240,232,0.08)`, borderTop: 'none' }} />
            </div>
            {/* Design selector dots */}
            <div style={{ display: 'flex', gap: 10, justifyContent: 'center', marginTop: 20 }}>
              {designs.map((d, i) => (
                <button key={d.id} onClick={() => setActiveDesign(i)}
                  style={{ width: i === activeDesign ? 28 : 8, height: 8, background: i === activeDesign ? 'var(--ember)' : 'rgba(245,240,232,0.2)', border: 'none', borderRadius: 4, transition: 'all 0.3s' }} />
              ))}
            </div>
          </div>

          <div>
            <div style={{ fontFamily: 'var(--font-display)', fontSize: 48, color: 'var(--white)', marginBottom: 8 }}>{designs[activeDesign].name}</div>
            <p style={{ fontFamily: 'var(--font-serif)', fontStyle: 'italic', fontSize: 18, color: 'rgba(245,240,232,0.5)', marginBottom: 24, lineHeight: 1.6 }}>{designs[activeDesign].desc}</p>
            <div style={{ display: 'flex', gap: 16, marginBottom: 32, flexWrap: 'wrap' }}>
              {products.map(p => (
                <div key={p.type} style={{ padding: '12px 20px', border: '1px solid rgba(245,240,232,0.12)', fontSize: 13, color: 'rgba(245,240,232,0.6)' }}>
                  <span style={{ color: 'var(--white)' }}>{p.type}</span> — <span style={{ color: 'var(--gold)' }}>{p.price}</span>
                </div>
              ))}
            </div>
            <div style={{ fontSize: 11, letterSpacing: '0.15em', color: 'rgba(245,240,232,0.3)', marginBottom: 20, textTransform: 'uppercase' }}>
              Colorway: {designs[activeDesign].colorway} &nbsp;·&nbsp; Sizes XS–XXL &nbsp;·&nbsp; Pre-order only
            </div>
            <button onClick={() => setSelectedDesign(designs[activeDesign])}
              style={{ background: 'var(--ember)', color: 'var(--white)', border: 'none', padding: '16px 40px', fontFamily: 'var(--font-body)', fontSize: 12, fontWeight: 500, letterSpacing: '0.2em', textTransform: 'uppercase' }}
              onMouseEnter={e => e.target.style.background = 'var(--ember-light)'}
              onMouseLeave={e => e.target.style.background = 'var(--ember)'}>
              Pre-Order This Design
            </button>
          </div>
        </div>

        {/* All designs grid */}
        <div>
          <p style={{ fontSize: 10, letterSpacing: '0.3em', textTransform: 'uppercase', color: 'rgba(245,240,232,0.3)', marginBottom: 28 }}>All Designs</p>
          <div className="merch-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16 }}>
            {designs.map((d, i) => (
              <div key={d.id} className={`merch-card reveal reveal-d${Math.min(i+1,4)}`}
                style={{ border: `1px solid ${activeDesign === i ? 'rgba(200,68,10,0.5)' : 'rgba(245,240,232,0.06)'}`, overflow: 'hidden', cursor: 'pointer' }}
                onClick={() => { setActiveDesign(i); window.scrollBy({ top: -500, behavior: 'smooth' }); }}
                onMouseEnter={() => setHovered(i)}
                onMouseLeave={() => setHovered(null)}>
                <div style={{ background: d.hex, aspectRatio: '3/4', position: 'relative', overflow: 'hidden' }}>
                  <div style={{ position: 'absolute', inset: '10%' }}>
                    {d.svg}
                  </div>
                </div>
                <div style={{ padding: '14px 16px', background: 'var(--ash-mid)' }}>
                  <div style={{ fontFamily: 'var(--font-display)', fontSize: 18, color: 'var(--white)', marginBottom: 2 }}>{d.name}</div>
                  <div style={{ fontSize: 11, color: 'var(--ember)', letterSpacing: '0.12em' }}>{d.colorway}</div>
                  <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                    {products.map(p => (
                      <button key={p.type} onClick={e => { e.stopPropagation(); setSelectedDesign(d); }}
                        style={{ flex: 1, background: hovered === i ? 'var(--ember)' : 'rgba(200,68,10,0.1)', color: 'var(--white)', border: '1px solid rgba(200,68,10,0.2)', padding: '8px 4px', fontFamily: 'var(--font-body)', fontSize: 10, letterSpacing: '0.1em', textTransform: 'uppercase', transition: 'background 0.3s' }}>
                        {p.type.includes('Tee') ? 'Tee' : 'Hoodie'} {p.price}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Merch note */}
        <div className="reveal" style={{ marginTop: 64, padding: '32px 40px', border: '1px solid rgba(212,168,67,0.15)', background: 'rgba(212,168,67,0.03)', display: 'flex', gap: 32, alignItems: 'center', flexWrap: 'wrap' }}>
          <div style={{ flex: 1, minWidth: 240 }}>
            <p style={{ fontSize: 10, letterSpacing: '0.25em', textTransform: 'uppercase', color: 'var(--gold)', marginBottom: 8 }}>Pre-Order Info</p>
            <p style={{ fontSize: 14, color: 'rgba(245,240,232,0.5)', lineHeight: 1.7 }}>
              All items are produced to order. Pre-orders close 2 weeks before each city's REVIVE event. 
              Items ship 2–3 weeks after the event. Payment is collected at fulfilment — 
              no charge until your order ships.
            </p>
          </div>
          <button onClick={() => setSelectedDesign(designs[0])}
            style={{ background: 'transparent', color: 'var(--gold)', border: '1px solid rgba(212,168,67,0.3)', padding: '14px 32px', fontFamily: 'var(--font-body)', fontSize: 12, letterSpacing: '0.2em', textTransform: 'uppercase', whiteSpace: 'nowrap' }}
            onMouseEnter={e => { e.target.style.borderColor = 'var(--gold)'; e.target.style.background = 'rgba(212,168,67,0.08)'; }}
            onMouseLeave={e => { e.target.style.borderColor = 'rgba(212,168,67,0.3)'; e.target.style.background = 'transparent'; }}>
            Start Pre-Order →
          </button>
        </div>
      </section>
    </>
  );
}
